import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import { IndustryItem } from '../industryForm/industryForm.types';

export const getIndustryList = async () => {
  const { customerId } = useBoundStore.getState().customer;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/industryList`
    : `v3/secureonboarding/user/${customerId}/industryList`;
  const { data } = await HttpService.get(url);
  return data?.industryList as IndustryItem[];
};
